// 路由守卫
import router from './router'
import store from './store'
import { getToken } from './utils/auth'

router.beforeEach((to, from, next) => {
  console.log('获取到的token', getToken())
  if (!store.state.token) {
    store.state.token = getToken()
  }
  const token = store.state.token

  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.path === '/login') {
    // 已登录用户访问登录页，重定向到首页
    next()
  } else if (!to.meta.noAuth) {
    // 需要登录的页面
    if (!token) {
      // 未登录，重定向到登录页
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    // 不需要登录的页面，直接放行
    next()
  }
})
